module.exports = __webpack_public_path__ + "img/add_grey.9a023340.svg";